import React, { Fragment } from "react";
import Moment from "moment";
import "date-fns";
import PropTypes from "prop-types";
import { isEmpty } from "lodash";
import Grid from "@mui/material/Grid";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { CircularProgress, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { API_URL, ADMIN_TYPE } from "../../utils/Constants";
import { ApiService } from "../../utils/ApiService";
import {
  Chips,
  TextInput,
  CustomizeColumns,
  CustomDropdown,
  DownloadReport,
  DeleteReport,
  Label12,
  Label16,
  Label18,
} from "../../components";
import "../../App.css";
import {
  NoReportsLogo,
  CustomizeLogo,
  PlainDeleteLogo,
  PlainEditLogo,
} from "../../assets/icons";
import { colors } from "../../config/colors";
import { DISPLAY_FLEX, MAX_WIDTH, TEXT_ALIGN_LEFT } from "../../config/styles";
import { ModalSyled } from "./styled";
import { REGEX_VALIDATIONS } from "../../config/constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

class ReportsSchedule extends React.Component {
  constructor(props) {
    super(props);

    this.adminType = localStorage.getItem("role");
    this.scheduleSuccessMsg = "Report Scheduled Successfully.";
    this.state = {
      isNetworking: false,
      snackMsg: this.scheduleSuccessMsg,
      showSnack: false,
      isCustomReport: true,
      isTransactionReport: false,
      selectAll: false,
      department: false,
      external: false,
      card: false,
      customer: false,
      deliveryDate: false,
      transaction: false,
      allCriteria: false,
      showCustomReport: false,
      pageNo: 0,
      pageSize: 10,
      TotalCount: "",
      loader: true,
      CustomReportCount: 1,
      isViewCustomReport: false,
      isEditCustomReport: false,
      isDeleteCustomReport: false,
      reportType: "",
      schoolAdmin: false,
      isColumnsChanged: false,
      downloadLink: "",
      allFieldsName: [],
      isFetching: false,
      SelectedCol: [],
      checked: false,
      customReportName: "",
      tabSelectvalue: 0,
      allCustomTemplate: [],
      allCustomTemplate_Loading: true,
      TotalCount: "",
      seteachCustom: "",

      frequency: ["", "Monthly", "Weekly", "Daily"],
      Date: [
        "",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],
      Day: [
        "",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      selectedFrequency: "",
      selectedDate: "",
      startDate: Moment().format("YYYY-MM-DD"),
      selectedDay: "",
      selectedDayIndex: "",
      displayDate: false,
      displayDay: false,
      scheduleName: "",
      emailEntered: "",
      emailList: [],
      isNetworking: false,
      reportCategory: "STANDARD",
      showLink: true,
      emailCount: 0,
      isName: false,
      isEmail: false,
      isAdd: false,
      isFreq: false,
      isDay: false,
      isDate: false,
      isInvalidEmail: false,
      isDuplicateEmail: false,
      DisableAdd: false,
      superAdmin: "-1",
    };
  }
  componentDidMount() {
    let role = localStorage.getItem("role");
    if (role == "SCHOOLADMIN") {
      this.setState({ schoolAdmin: true });
    }
  }

  getReportType = () =>
    this.state.isEditCustomReport
      ? this.state.seteachCustom.reportType
      : this.state.reportType === "Transaction Reports"
        ? "TRANSACTION"
        : this.state.reportType === "Student Registration Reports"
          ? "STUDENT_REGISTRATION"
          : this.state.reportType === "User Registration Reports"
            ? "USER_REGISTRATION"
            : this.state.reportType === "User Student Reports"
              ? "USER_STUDENT"
              : null;

  getTemplateName = () =>
    this.state.isEditCustomReport
      ? this.state.seteachCustom.templateName
      : this.state.customReportName

  handleCustomModal = async () => {
    this.setState({ showCustomReport: true });
  };

  onCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({ showSnack: false });
  };
  onFetchAllTemplates = async () => {
    const url =
      API_URL.REPORT_GET_ALL_FIELDNAMES + this.state.seteachCustom.Type;
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };
  onTransactionReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Transaction Reports",
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "TRANSACTION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };
  onTransactionReportsView = (item) => {
    this.setState({ isViewCustomReport: true, isCustomReport: false });
  };

  onConvenienceFeeReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Convenience Fee Reports",
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "CONVENIENCE_FEE";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onUserRegistrationReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "User Registration Reports",
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "USER_REGISTRATION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onUserStudentReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "User Student Reports",
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "USER_STUDENT";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };

  onStudentRegistrationReports = async () => {
    this.setState(
      {
        isFetching: false,
        isTransactionReport: true,
        reportType: "Student Registration Reports",
        SelectedCol: [],
      },
      this.props.onHideTabs
    );
    const url = API_URL.REPORT_GET_ALL_FIELDNAMES + "STUDENT_REGISTRATION";
    const response = await ApiService.getRequest(url);
    if (!isEmpty(response)) {
      this.setState({ allFieldsName: response, isFetching: true });
    }
  };
  backButton = () => {
    this.setState(
      {
        isTransactionReport: false,
        isViewCustomReport: false,
        isEditCustomReport: false,
        scheduleName: "",
        emailList: [],
        emailCount: 0,
        selectedFrequency: "",
        selectedDay: "",
        selectedDate: "",
        isEmail: false,
        isFreq: false,
        isName: false,
        isDate: false,
        isDay: false,
      },
      this.props.onShowTabs
    );
  };
  handleChange = async (event, newValue) => {
    this.setState(
      {
        tabSelectvalue: newValue,
        isTransactionReport: false,
        showSnack: false,
        showLink: false,
        downloadLink: "",
        scheduleName: "",
        emailList: [],
        emailCount: 0,
        selectedFrequency: "",
        selectedDay: "",
        selectedDate: "",
        isEmail: false,
        isFreq: false,
        isName: false,
        isDate: false,
        isDay: false,
      },
      this.props.onShowTabs
    );
    if (this.state.tabSelectvalue === 1) {
      this.setState({ isViewCustomReport: false, isEditCustomReport: false });
    }
    let tabSelection = this.props.tabSelection;
    let url = "";
    if (newValue === 1) {
      let GlobalMerchantId = localStorage.getItem("globalMerchantId");
      let SchoolMerchantId = localStorage.getItem("schoolAdminMerchantId");

      if (tabSelection === "MainLanding") {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          "-1" +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      } else if (
        this.adminType === ADMIN_TYPE.SUPERADMIN ||
        this.adminType === ADMIN_TYPE.SALESADMIN
      ) {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          GlobalMerchantId +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      } else {
        url =
          API_URL.REPORT_CUSTOM_ALL +
          SchoolMerchantId +
          "?offset=" +
          this.state.pageNo +
          "&limit=" +
          this.state.pageSize;
      }
      const resp = await ApiService.getRequest(url);
      if (resp && resp.status && resp.status.code === "Y") {
        this.setState({
          allCustomTemplate: resp.body,
          isTemplateFound: true,
          allCustomTemplate_Loading: false,
        });
        this.setState({ TotalCount: parseInt(resp.status.message) });
      } else {
        this.setState({ isTemplateFound: false });
      }
    }
  };

  onSaveCustomColumns = () => {
    this.setState({ isColumnsChanged: true, show: false });
    this.RefreshGrids();
  };

  handleCreateUser = async () => {
    this.setState({ show: true, showLink: true });
    if (this.state.isEditCustomReport) {
      const url =
        API_URL.REPORT_GET_ALL_FIELDNAMES + this.state.seteachCustom.reportType;
      const response = await ApiService.getRequest(url);
      if (!isEmpty(response)) {
        this.setState({ allFieldsName: response, isFetching: true });
      }
    }
  };

  handleHide = () => {
    this.setState({ show: false });
    this.setState({ SelectedCol: [] });
  };

  onHideCustomModal = () => {
    this.setState({ showCustomReport: false, isDeleteCustomReport: false });
    this.setState({ isColumnsChanged: false });
  };

  onCustomNameChange = (event) => {
    this.setState({ customReportName: event.target.value });
  };
  onUpdateCustomModal = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.adminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");
    try {
      let data = "";
      data = {
        headerList: this.state.SelectedCol,
        merchantId: merchantId,
        reportType: this.getReportType(),
        templateName: this.getTemplateName(),
      };
      const resp = await ApiService.postRequest(
        API_URL.REPORT_CUSTOM_UPDATE + this.state.seteachCustom.customReportId,
        data
      );

      if (resp.status && resp.status.code === "Y") {
        this.setState(
          {
            showCustomReport: false,
            SelectedCol: [],
            isDeleteCustomReport: false,
            showSnack: true,
            snackMsg: "Report Saved Successfully",
          },
          this.props.onShowTabs
        );
        this.setState({ isColumnsChanged: false, isEditCustomReport: false });
      } else {
        this.setState(
          {
            showCustomReport: false,
            isDeleteCustomReport: false,
            SelectedCol: [],
            showSnack: true,
            snackMsg: resp.status.message,
          },
          this.props.onShowTabs
        );
        this.setState({ isColumnsChanged: false, isEditCustomReport: false });
      }
    } catch (err) {
      this.setState({
        showCustomReport: false,
        isDeleteCustomReport: false,
        SelectedCol: [],
      });
      this.setState(
        { isColumnsChanged: false, isEditCustomReport: false },
        this.props.onShowTabs
      );
    }
    this.handleRefresh();
  };

  onSaveCustomModal = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.adminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");
    try {
      let data = "";
      data = {
        headerList: this.state.SelectedCol,
        merchantId: merchantId,
        reportType: this.getReportType(),
        templateName: this.getTemplateName(),
      };

      const resp = await ApiService.postRequest(
        API_URL.REPORT_CUSTOM_SAVE,
        data
      );

      if (resp.status && resp.status.code === "Y") {
        this.setState({ showCustomReport: false, isDeleteCustomReport: false });
        this.setState({
          isColumnsChanged: false,
          SelectedCol: [],
          customReportName: "",
          showSnack: true,
          snackMsg: "Custom Report Saved Successfully",
        });
      } else {
        this.setState({ showCustomReport: false, isDeleteCustomReport: false });
        this.setState({
          isColumnsChanged: false,
          SelectedCol: [],
          customReportName: "",
          showSnack: true,
          snackMsg: resp.status.message,
        });
      }
    } catch (err) {
      this.setState({ showCustomReport: false, isDeleteCustomReport: false });
      this.setState({
        isColumnsChanged: false,
        SelectedCol: [],
        customReportName: "",
        showSnack: true,
        snackMsg: err?.message,
      });
    }
  };

  onCheckAllCriteria = () => {
    let allValue = false;
    allValue =
      this.state.selectAll &&
      this.state.department &&
      this.state.external &&
      this.state.card &&
      this.state.customer &&
      this.state.deliveryDate &&
      this.state.transaction;
    this.setState({ allCriteria: allValue });
  };

  handleShowEdit = () => {
    this.setState({ isEditCustomReport: true, isViewCustomReport: false });
  };

  handleShowDelete = () => {
    this.setState({ isDeleteCustomReport: true, isViewCustomReport: false });
  };

  onReset = () => {
    this.setState({ SelectedCol: [] });
  };

  onCheckAllCriteria = () => {
    this.setState({
      selectAll: !this.state.selectAll,
      department: !this.state.department,
      external: this.state.external,
      card: !this.state.card,
      customer: !this.state.customer,
      deliveryDate: !this.state.deliveryDate,
      transaction: !this.state.transaction,
    });
  };

  onDeleteCustomTemplate = async () => {
    let merchantId =
      this.props.tabSelection === "MainLanding"
        ? this.state.superAdmin
        : this.adminType === ADMIN_TYPE.SCHOOLADMIN
          ? localStorage.getItem("schoolAdminMerchantId")
          : localStorage.getItem("globalMerchantId");
    const url =
      API_URL.REPORT_CUSTOM_DELETE +
      merchantId +
      "/" +
      this.state.seteachCustom.customReportId;
    const response = await ApiService.deleteRequest(url);

    if (
      (response.error != undefined && response.error.status_code === 401) ||
      response.status === "403"
    ) {
      this.setState({ isDeleteCustomReport: false });
      return;
    }
    if (response.status.code == "Y") {
      this.setState({
        isDeleteCustomReport: false,
        snackMsg: response.status.message,
        showSnack: true,
      });
      this.handleRefresh();
    }
  };

  async handleRefresh() {
    this.setState({ allCustomTemplate_Loading: true });
    let GlobalMerchantId = localStorage.getItem("globalMerchantId");
    let schoolAdminMerchantId = localStorage.getItem("schoolAdminMerchantId");
    let tabSelection = this.props.tabSelection;
    let url = "";
    if (tabSelection === "MainLanding") {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        "-1" +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    } else if (
      this.adminType === ADMIN_TYPE.SUPERADMIN ||
      this.adminType === ADMIN_TYPE.SALESADMIN
    ) {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        GlobalMerchantId +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    } else {
      url =
        API_URL.REPORT_CUSTOM_ALL +
        schoolAdminMerchantId +
        "?offset=" +
        this.state.pageNo +
        "&limit=" +
        this.state.pageSize;
    }
    const resp = await ApiService.getRequest(url);
    if (resp && resp.status && resp.status.code === "Y") {
      this.setState({
        allCustomTemplate: resp.body,
        isTemplateFound: true,
        allCustomTemplate_Loading: false,
      }); //,TotalCount:resp.body.length      TotalCount:parseInt(resp.status.message)  ,
      this.setState({ TotalCount: parseInt(resp.status.message) });
    } else {
      this.setState({ isTemplateFound: false });
    }
  }

  handleScheduleReport = async () => {
    try {
      let finalDate = "";
      let merchantId = "";
      let tabSelection = this.props.tabSelection;
      if (tabSelection === "MainLanding") {
        merchantId = "-1";
      } else {
        merchantId = localStorage.getItem("globalMerchantId");
      }
      let data = "";
      const moment = require("moment");
      let now = Moment();
      let year = now.get("year");
      let month = now.get("month");
      let date = now.get("date");

      let week_Date = Moment()
        .day(this.state.selectedDayIndex)
        .format("YYYY-MM-DD");
      let week_Date_no = Moment().day(this.state.selectedDayIndex).get("date");
      let new_date = "";
      {
        Moment(week_Date).isSameOrBefore(this.state.startDate)
          ? (new_date = moment(week_Date).add(7, "days").format("YYYY-MM-DD"))
          : (new_date = week_Date);
      }
      let tomorrow = Moment().add(1, "days").format("YYYY-MM-DD");
      // for month
      if (this.state.selectedDate > date) {
        if (this.state.selectedDate < 10) {
          if (month < 9) {
            finalDate =
              year +
              "-0" +
              (month + 1) +
              "-0" +
              this.state.selectedDate +
              "T12:00:00";
          } else {
            finalDate =
              year +
              "-" +
              (month + 1) +
              "-0" +
              this.state.selectedDate +
              "T12:00:00";
          }
        } else {
          if (month < 9) {
            finalDate =
              year +
              "-0" +
              (month + 1) +
              "-" +
              this.state.selectedDate +
              "T12:00:00";
          } else {
            finalDate =
              year +
              "-" +
              (month + 1) +
              "-" +
              this.state.selectedDate +
              "T12:00:00";
          }
        }
      } else if (this.state.selectedDate <= date) {
        if (this.state.selectedDate < 10) {
          if (month < 8) {
            finalDate =
              year +
              "-0" +
              (month + 2) +
              "-0" +
              this.state.selectedDate +
              "T12:00:00";
          } else {
            finalDate =
              year +
              "-" +
              (month + 2) +
              "-0" +
              this.state.selectedDate +
              "T12:00:00";
          }
        } else {
          if (month < 8) {
            finalDate =
              year +
              "-0" +
              (month + 2) +
              "-" +
              this.state.selectedDate +
              "T12:00:00";
          } else {
            finalDate =
              year +
              "-" +
              (month + 2) +
              "-" +
              this.state.selectedDate +
              "T12:00:00";
          }
        }
      }
      // for custom
      if (this.state.tabSelectvalue === 1) {
        data = {
          customTemplateName: this.state.scheduleName,
          emailList: this.state.emailList,
          frequency:
            this.state.selectedFrequency === "Daily"
              ? "D"
              : this.state.selectedFrequency === "Weekly"
                ? "W"
                : this.state.selectedFrequency === "Monthly"
                  ? "M"
                  : "D",
          merchantId: merchantId,
          reportCategory: "CUSTOM",
          scheduledIntervalPeriod:
            this.state.selectedFrequency === "Daily"
              ? ""
              : this.state.selectedFrequency === "Weekly"
                ? this.state.selectedDay
                : this.state.selectedFrequency === "Monthly"
                  ? this.state.selectedDate
                  : "",
          reportName: this.state.scheduleName,
          startDate:
            this.state.selectedFrequency === "Daily"
              ? tomorrow + "T12:00:00"
              : this.state.selectedFrequency === "Weekly"
                ? new_date + "T12:00:00"
                : this.state.selectedFrequency === "Monthly"
                  ? finalDate
                  : null,
          type: this.state.seteachCustom.reportType,
        };
      }
      //Standard
      if (this.state.tabSelectvalue === 0) {
        data = {
          emailList: this.state.emailList,
          frequency:
            this.state.selectedFrequency === "Daily"
              ? "D"
              : this.state.selectedFrequency === "Weekly"
                ? "W"
                : this.state.selectedFrequency === "Monthly"
                  ? "M"
                  : "D",
          merchantId: merchantId,
          reportCategory: "STANDARD",
          scheduledIntervalPeriod:
            this.state.selectedFrequency === "Daily"
              ? ""
              : this.state.selectedFrequency === "Weekly"
                ? this.state.selectedDay
                : this.state.selectedFrequency === "Monthly"
                  ? this.state.selectedDate
                  : "",
          reportName: this.state.scheduleName,
          startDate:
            this.state.selectedFrequency === "Daily"
              ? tomorrow + "T12:00:00"
              : this.state.selectedFrequency === "Weekly"
                ? new_date + "T12:00:00"
                : this.state.selectedFrequency === "Monthly"
                  ? finalDate
                  : this.state.startDate + "T12:00:00",
          type:
            this.state.reportType === "Transaction Reports"
              ? "TRANSACTION"
              : this.state.reportType === "Convenience Fee Reports"
                ? "CONVENIENCE_FEE"
                : this.state.reportType === "Student Registration Reports"
                  ? "STUDENT_REGISTRATION"
                  : this.state.reportType === "User Registration Reports"
                    ? "USER_REGISTRATION"
                    : this.state.reportType === "User Student Reports"
                      ? "USER_STUDENT"
                      : null,
        };
      }
      const resp = await ApiService.postRequest(
        API_URL.REPORTS_SCHEDULED_CREATE,
        data
      );

      if (resp.status && resp.status.code === "Y") {
        this.setState({
          showSnack: true,
          snackMsg: this.scheduleSuccessMsg,
          downloadLink: resp.status.message,
          scheduleName: "",
          emailEntered: "",
          emailList: [],
          selectedDate: "",
          selectedDay: "",
          selectedFrequency: "",
        });
      } else {
        this.setState({
          isNetworking: false,
          snackMsg: resp.status.message,
          showSnack: true,
        });
      }
    } catch (err) {
      this.setState({ isNetworking: false });
    }
  };

  onFrequencySelected = (key) => {
    const value = this.state.frequency[key];
    if (value === "Monthly") {
      this.setState({ selectedFrequency: "Monthly", isFreq: true });
      this.setState({ displayDate: true });
      this.setState({ displayDay: false });
    }
    if (value === "Weekly") {
      this.setState({ selectedFrequency: "Weekly", isFreq: true });
      this.setState({ displayDay: true });
      this.setState({ displayDate: false });
    }
    if (value === "Daily") {
      this.setState({ selectedFrequency: "Daily", isFreq: true });
      this.setState({ displayDay: false });
      this.setState({ displayDate: false });
    }
  };
  onDateChange = (key) => {
    const value = this.state.Date[key];
    this.setState({ selectedDate: value, isDate: true });
  };
  onDayChange = (key) => {
    const value = this.state.Day[key];
    this.setState({ selectedDay: value, selectedDayIndex: key, isDay: true });
  };
  onChangeScheduleName = (event) => {
    this.setState({ isName: true, scheduleName: event.target.value });
  };
  onChangeEmailAddress = (event) => {
    if (this.state.emailList.includes(event.target.value) === true) {
      this.setState({
        DisableAdd: true,
        emailEntered: event.target.value,
      });
    } else {
      this.setState({
        DisableAdd: false,
        isEmail: true,
        emailEntered: event.target.value,
      });
    }
  };
  onClickAdd = () => {
    if (REGEX_VALIDATIONS.email.test(this.state.emailEntered) === true) {
      this.setState({
        isInvalidEmail: false,
        isAdd: true,
        emailCount: this.state.emailCount + 1,
        emailList: [...this.state.emailList, this.state.emailEntered],
      });
    } else if (this.state.emailEntered == "") {
      this.setState({ DisableAdd: true });
    } else {
      this.setState({ isInvalidEmail: true });
    }
    this.setState({ emailEntered: "" });
  };

  RefreshGrids = () => {
    const columnChips =
      this.state.isColumnsChanged && this.state.SelectedCol.length > 0
        ? this.state.SelectedCol
        : this.state.allFieldsName;
    return (
      <div>
        <Grid container style={{ display: "flexGrow", margin: 10 }} spacing={1}>
          {columnChips.map((item) => (
            <Grid item spacing={2}>
              <Chips className="column_chips" disabled label={item} />
            </Grid>
          ))}
        </Grid>
      </div>
    );
  };

  renderNoCustomReports = () => {
    return (
      <div className="d-flex flex-column w-100 h-100 gap-3 justify-content-center align-items-center mt-5">
        <NoReportsLogo />
        <Typography variant="body1">
          You have not created any custom reports
        </Typography>
      </div>
    );
  };

  renderCustomReports = () => {
    return (
      <div className="w-100 my-3">
        {this.state.isTemplateFound ? (
          <Fragment>
            <Typography sx={{ textAlign: TEXT_ALIGN_LEFT }} variant="h5">
              Custom Reports
            </Typography>
            <div className="d-flex gap-3 flex-wrap py-4 w-100 justify-content-between">
              {this.state.allCustomTemplate.map((item) => (
                <div className="custom-card-container">
                  <div className="d-flex justify-content-between align-items-center">
                    <button
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        width: '70%',
                        overflow: 'hidden',
                      }}
                      onClick={() =>
                        this.setState(
                          {
                            isViewCustomReport: true,
                            isCustomReport: false,
                            seteachCustom: item,
                          },
                          this.props.onHideTabs
                        )
                      }
                    >
                      <Typography variant="h5" sx={{ color: colors.primary, textAlign: TEXT_ALIGN_LEFT }}>
                        {item.templateName}
                      </Typography>
                      <Typography variant="h4" sx={{ color: colors.grayLight, textAlign: TEXT_ALIGN_LEFT }}>
                        {item.reportType}
                      </Typography>
                    </button>
                    <div className="d-flex flex-row gap-2">
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        onClick={() =>
                          this.setState({
                            isDeleteCustomReport: true,
                            isViewCustomReport: false,
                            seteachCustom: item,
                          })
                        }
                      >
                        <PlainDeleteLogo />
                      </button>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "none",
                        }}
                        onClick={() =>
                          this.setState(
                            {
                              isEditCustomReport: true,
                              isViewCustomReport: false,
                              seteachCustom: item,
                            },
                            this.props.onHideTabs
                          )
                        }
                      >
                        <PlainEditLogo />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Fragment>
        ) : (
          <Typography variant="h5">{this.state.TemplateErrorMsg}</Typography>
        )}
      </div>
    );
  };

  renderGenerateReport = () => {
    return (
      <Fragment>
        <div className="view-report-container w-100 pb-4">
          <Typography variant="h5" className="pb-4">
            Report type
          </Typography>
          <Form.Floating
            as={Row}
            className="mb-3 mx-1 w-100"
            controlId=""
            key="Type"
          >
            <Form.Control
              type="text"
              autocomplete="off"
              value={this.state.reportType}
              disabled={true}
              className="disabled-form-input"
            />
            <label>Type</label>
          </Form.Floating>
        </div>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-2">
            Schedule Report Details
          </Typography>
          <div className="d-flex w-100 justify-content-between gap-3">
            <TextInput
              id="scheduleName"
              label="Schedule Name"
              style={{ width: MAX_WIDTH, marginTop: 16 }}
              value={this.state.scheduleName}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
              onChange={this.onChangeScheduleName}
            />
            <TextInput
              id="emailAddress"
              label="Email Address"
              style={{ width: MAX_WIDTH, marginTop: 16 }}
              value={this.state.emailEntered}
              onChange={this.onChangeEmailAddress}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
            />
          </div>
          <Button
            className="add_Btn"
            onClick={this.onClickAdd}
            disabled={
              this.adminType === ADMIN_TYPE.SALESADMIN ||
              this.adminType === ADMIN_TYPE.SCHOOLADMIN ||
              this.state.emailCount > 19 ||
              this.state.DisableAdd
            }
          >
            Add
          </Button>
          <div style={{ color: "#6d758e" }} className="pb-3">
            <Typography variant="h4"> Maximum 20 Allowed </Typography>
            {this.state.isInvalidEmail ? (
              <div
                style={{
                  color: "#FF0000",
                  fontSize: 12,
                  fontFamily: "Open Sans",
                  opacity: "70%",
                }}
              >
                Invalid Email Format !!!
              </div>
            ) : null}
          </div>
          <div className="d-flex flex-row w-100 pb-3">
            <Grid
              container
              style={{ display: "flexGrow", margin: 10 }}
              spacing={1}
            >
              {this.state.emailList.map((item) => (
                <Grid item spacing={2} key={item}>
                  <Chips
                    className="column_chips"
                    onClose={this.removeItem}
                    label={item}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>

        <div className="view-report-container">
          <div className="d-flex justify-content-between align-items-center w-100 p-2">
            <Typography variant="h5" component={"div"}>
              Customize columns
            </Typography>
            <Button
              style={{
                background: "none",
                border: "none",
                padding: 0,
                color: colors.primary,
                display: DISPLAY_FLEX,
              }}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
              onClick={this.handleCreateUser}
            >
              <PlainEditLogo />
              <Typography sx={{ marginLeft: 1 }} variant="body1">
                Edit
              </Typography>
            </Button>
          </div>
          <div className="d-flex flex-row w-100">
            {this.state.isFetching ? (
              this.RefreshGrids()
            ) : (
              <div
                style={{
                  alignSelf: "center",
                  padding: 16,
                  marginLeft: "45%",
                  marginTop: "5%",
                }}
              >
                <CircularProgress size={24} thickness={5} />
              </div>
            )}
          </div>
        </div>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-2">
            Schedule Frequency
          </Typography>
          <div className="d-flex w-100 justify-content-between gap-3 my-2">
            <CustomDropdown
              style={{ marginTop: 16, width: "50%" }}
              label="Frequency"
              items={this.state.frequency}
              value={this.state.selectedFrequency}
              onChange={this.onFrequencySelected}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
            />
            {this.state.displayDate ? (
              <CustomDropdown
                style={{ marginTop: 16, width: "50%" }}
                label="Date"
                items={this.state.Date}
                value={this.state.selectedDate}
                onChange={this.onDateChange}
              />
            ) : null}
            {this.state.displayDay ? (
              <CustomDropdown
                style={{ marginTop: 16, width: "50%" }}
                label="Day"
                items={this.state.Day}
                value={this.state.selectedDay}
                onChange={this.onDayChange}
              />
            ) : null}
          </div>
        </div>
        <div className="view-report-container d-flex flex-row gap-3">
          {this.state.isColumnsChanged && this.state.SelectedCol.length > 0 ? (
            <Button
              className="cancel-button w-100"
              onClick={this.handleCustomModal}
            >
              Save As Custom Report
            </Button>
          ) : null}
          {this.state.isNetworking ? (
            <Button
              className="cancel-button w-100"
              onClick={this.handleCustomModal}
            >
              Cancel
            </Button>
          ) : null}
          <Button
            className="generate-button w-100"
            onClick={this.handleScheduleReport}
            isLoading={this.state.isNetworking}
            disabled={
              !this.state.isFreq ||
              this.state.scheduleName.length < 1 ||
              this.state.emailList.length < 1 ||
              !(this.state.selectedFrequency === "Daily"
                ? true
                : this.state.selectedFrequency === "Monthly" &&
                  this.state.isDate
                  ? true
                  : this.state.selectedFrequency === "Weekly" && this.state.isDay
                    ? true
                    : false)
            }
          >
            Generate Report
          </Button>
        </div>
      </Fragment>
    );
  };

  renderViewReportType = () => {
    return (
      <div className="divRow">
        <div style={{ width: "50%" }}>
          <div style={{ marginTop: 0, marginRight: 20 }}>
            <Label18 bold>Report Details</Label18>
          </div>
          <div
            className="select_Report"
            style={{ marginBottom: 24, marginTop: 20 }}
          >
            <div className="divRow" style={{ marginBottom: 20 }}>
              <div style={{ wordBreak: "break-word" }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                  }}
                >
                  Custom Report Name
                </div>
                <div>
                  <Label16>{this.state.seteachCustom.templateName}</Label16>
                </div>
              </div>
              <div style={{ marginLeft: 60 }}>
                <div
                  style={{
                    color: "#6d758e",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                  }}
                >
                  Report Type
                </div>
                <div>
                  <Label16>CUSTOM</Label16>
                </div>
              </div>
            </div>
            <div style={{ marginLeft: 0, marginBottom: 20 }}>
              <div
                style={{
                  color: "#6d758e",
                  fontSize: 12,
                  fontFamily: "Open Sans",
                  opacity: "70%",
                }}
              >
                Report Name
              </div>
              <div style={{ marginLeft: 0 }}>
                <Label16>{this.state.seteachCustom.reportType}</Label16>
              </div>
            </div>
            <Label18 bold>Schedule Report Details</Label18>
            <TextInput
              id="scheduleName"
              label="Schedule Name"
              style={{ width: "100%", marginTop: 16 }}
              value={this.state.scheduleName}
              onChange={this.onChangeScheduleName}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
            />
            <TextInput
              id="emailAddress"
              label="Email Address"
              style={{ width: "70%", marginTop: 16 }}
              value={this.state.emailEntered}
              onChange={this.onChangeEmailAddress}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN
              }
            />
            <Button
              className="add_Btn"
              onClick={this.onClickAdd}
              disabled={
                this.adminType === ADMIN_TYPE.SALESADMIN ||
                this.adminType === ADMIN_TYPE.SCHOOLADMIN ||
                this.state.emailCount > 19 ||
                this.state.DisableAdd
              }
            >
              Add
            </Button>
            <div style={{ color: "#6d758e" }}>
              <Label12> Maximum 20 Allowed</Label12>
              {this.state.isInvalidEmail ? (
                <div
                  style={{
                    color: "#FF0000",
                    fontSize: 12,
                    fontFamily: "Open Sans",
                    opacity: "70%",
                  }}
                >
                  Invalid Email Format !!!
                </div>
              ) : null}
            </div>
            <div>
              <Grid
                container
                style={{ display: "flexGrow", margin: 10 }}
                spacing={1}
              >
                {this.state.emailList.map((item) => (
                  <Grid item>
                    <Chips label={item} onClose={this.removeItem} />
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
          <Button
            style={{
              marginBottom: 20,
              width: 200,
              height: 40,
              marginTop: 20,
              marginRight: 10,
            }}
            className="primaryBtnAdd"
            onClick={this.handleScheduleReport}
            disabled={
              !this.state.isFreq ||
              this.state.scheduleName.length < 1 ||
              this.state.emailList.length < 1 ||
              !(this.state.selectedFrequency === "Daily"
                ? true
                : this.state.selectedFrequency === "Monthly" &&
                  this.state.isDate
                  ? true
                  : this.state.selectedFrequency === "Weekly" && this.state.isDay
                    ? true
                    : false)
            }
          >
            Schedule Report
          </Button>
        </div>
      </div>
    );
  };

  renderCustomModal() {
    return (
      <ModalSyled
        show={this.state.showCustomReport}
        onHide={this.onHideCustomModal}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Custom Report Name</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Please provide the below information to save the report. You can view
          / edit the custom reports on the Reports page.
          <TextInput
            label="Custom Report Name"
            value={this.state.customReportName}
            disabled={false}
            onChange={this.onCustomNameChange}
            style={{ width: "100%", margin: "1rem auto 0 auto" }}
          />
        </Modal.Body>
        <div className="d-flex flex-row justify-content-between gap-3 p-4">
          <Button
            className="cancel-button w-100"
            onClick={this.onHideCustomModal}
          >
            Cancel
          </Button>
          <Button
            className="generate-button w-100"
            onClick={this.onSaveCustomModal}
            disabled={
              this.state.customReportName.trim().replace(/\s+/g, "").length < 1
            }
          >
            Save As Custom Report
          </Button>
        </div>
      </ModalSyled>
    );
  }

  renderCreateUserModal() {
    return (
      <CustomizeColumns
        show={this.state.show}
        handleHide={this.handleHide}
        handleSave={this.onSaveCustomColumns}
        onChange={(item) => this.setState({ SelectedCol: item })}
        allFieldsName={this.state.allFieldsName}
        selectedFields={this.state.SelectedCol}
      />
    );
  }

  renderEditCustomView() {
    const editViewColumns =
      this.state.SelectedCol.length > 0
        ? this.state.SelectedCol
        : this.state.seteachCustom.headerList;
    return (
      <Fragment>
        <div className="view-report-container">
          <Typography variant="h5" className="pb-4">
            Report type
          </Typography>
          <div className="d-flex flex-column align-items-start gap-3 w-100 pb-3">
            <TextInput
              label="Custom Report Name"
              value={this.state.seteachCustom.templateName}
              disabled={true}
              className="w-100"
            />

            <TextInput
              label="Report Name"
              value={this.state.seteachCustom.reportType}
              disabled={true}
              className="w-100"
            />
          </div>
        </div>
        <div className="view-report-container">
          <div className="d-flex flex-row justify-content-between pb-4 w-100">
            <Typography variant="h5">Customize Columns</Typography>
            <button
              style={{ background: "transparent", border: "none" }}
              className="d-flex flex-row cursor-pointer"
              onClick={this.handleCreateUser}
            >
              <CustomizeLogo />
              <Typography variant="body1" sx={{ color: colors.primary }}>
                Edit
              </Typography>
            </button>
          </div>

          <div className="d-flex flex-row w-100">
            <Grid
              container
              style={{ display: "flexGrow", margin: 10 }}
              spacing={1}
            >
              {editViewColumns.map((item) => (
                <Grid item spacing={2}>
                  <Chips className="column_chips" disabled label={item} />
                </Grid>
              ))}
            </Grid>
          </div>
        </div>
        <div className="d-flex flex-row justify-content-between gap-3 pt-5">
          <Button
            className="cancel-button w-100"
            onClick={() =>
              this.setState(
                { isEditCustomReport: false, SelectedCol: [] },
                this.props.onShowTabs
              )
            }
          >
            Cancel
          </Button>
          <Button
            className="generate-button w-100"
            onClick={this.onUpdateCustomModal}
            disabled={this.state.SelectedCol.length < 1}
          >
            Save As Custom Report
          </Button>
        </div>
      </Fragment>
    );
  }

  renderDeleteCustomView() {
    return (
      <DeleteReport
        show={this.state.isDeleteCustomReport}
        onHide={this.onHideCustomModal}
        title={"Delete Custom Report"}
        onDone={this.onDeleteCustomTemplate}
      />
    );
  }
  renderDeleteEdit() {
    return (
      <div
        className="d-flex flex-row gap-2"
        style={{ marginTop: -70, float: "right" }}
      >
        <div style={{ marginRight: 10 }}>
          <Button
            className="tab-button"
            onClick={() =>
              this.setState({
                isEditCustomReport: true,
                isViewCustomReport: false,
              })
            }
            disabled={
              this.adminType === ADMIN_TYPE.SALESADMIN ||
              this.adminType === ADMIN_TYPE.SCHOOLADMIN
            }
          >
            Edit
          </Button>
        </div>

        <div>
          <Button
            className="tab-button"
            onClick={() => {
              this.handleShowDelete();
              this.setState(
                {
                  isDeleteCustomReport: true,
                  isViewCustomReport: false,
                },
                this.props.onShowTabs
              );
            }}
            disabled={
              this.adminType === ADMIN_TYPE.SALESADMIN ||
              this.adminType === ADMIN_TYPE.SCHOOLADMIN
            }
          >
            Delete
          </Button>
        </div>
      </div>
    );
  }

  renderViewStandard() {
    const roleData = localStorage.getItem("role");
    return (
      <div className="w-100 my-3">
        <Typography sx={{ textAlign: TEXT_ALIGN_LEFT }} variant="h5">
          Schedule Standard Reports
        </Typography>
        <div className="d-flex gap-3 flex-wrap py-4 w-100 justify-content-start">
          <div className="card-container">
            <Typography
              variant="h5"
              sx={{ color: colors.primary }}
              onClick={this.onTransactionReports}
            >
              Transaction Reports
            </Typography>
            <Typography variant="h4" sx={{ color: colors.grayLight }}>
              Product and bank reconcilliation details
            </Typography>
          </div>

          {roleData === ADMIN_TYPE.SUPERADMIN && (
            <div className="card-container">
              <Typography
                variant="h5"
                sx={{ color: colors.primary }}
                onClick={this.onConvenienceFeeReports}
              >
                Convenience Fee Report
              </Typography>
              <Typography variant="h4" sx={{ color: colors.grayLight }}>
                Convenince Fee Details
              </Typography>
            </div>
          )}

          {this.props.tabSelection === "MainLanding" ? (
            <Fragment>
              <div className="card-container">
                <Typography
                  variant="h5"
                  sx={{ color: colors.primary }}
                  onClick={this.onUserRegistrationReports}
                >
                  User Registration Reports
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grayLight }}>
                  Complete list of standalone users
                </Typography>
              </div>

              <div className="card-container">
                <Typography
                  variant="h5"
                  sx={{ color: colors.primary }}
                  onClick={this.onStudentRegistrationReports}
                >
                  Student Registration Reports
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grayLight }}>
                  Complete list of registered students
                </Typography>
              </div>

              <div className="card-container">
                <Typography
                  variant="h5"
                  sx={{ color: colors.primary }}
                  onClick={this.onUserStudentReports}
                >
                  User/Student Reports
                </Typography>
                <Typography variant="h4" sx={{ color: colors.grayLight }}>
                  User/Student registration details
                </Typography>
              </div>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.state.isViewCustomReport ? this.renderDeleteEdit() : null}
        <div>
          <div>
            <Tabs
              value={this.state.tabSelectvalue}
              indicatorColor="primary"
              textColor="primary"
              onChange={this.handleChange}
              aria-label="disabled tabs example"
            >
              <Tab label="Standard" {...a11yProps(0)} />
              <Tab label="Custom" {...a11yProps(1)} />
            </Tabs>
            <TabPanel
              value={this.state.tabSelectvalue}
              index={0}
              className="w-100"
            >
              <div className="d-flex w-100 flex-column gap-3">
                {this.state.isTransactionReport
                  ? this.renderGenerateReport()
                  : this.renderViewStandard()}
              </div>
            </TabPanel>
            <TabPanel value={this.state.tabSelectvalue} index={1}>
              <div className="d-block">
                <div className="custom-report-header">
                  {this.state.TotalCount === 0
                    ? this.renderNoCustomReports()
                    : this.state.isViewCustomReport
                      ? this.renderViewReportType()
                      : this.state.isEditCustomReport
                        ? this.renderEditCustomView()
                        : this.renderCustomReports()}
                </div>
              </div>
            </TabPanel>
          </div>
          <DownloadReport
            show={this.state.showSnack}
            onHide={this.onCloseSnack}
            title={this.state.snackMsg}
            message={
              this.state.tabSelectvalue === 0
                ? "Transaction report with product and bank reconciliation details successfully generated"
                : "Custom report with product and bank reconciliation details successfully generated"
            }
          />
        </div>
        {this.renderCreateUserModal()}
        {this.renderCustomModal()}
        {this.renderDeleteCustomView()}
      </div>
    );
  }
}

export default ReportsSchedule;
